export function addLoader() {
    const loaderNext = this.paginationNextElement;
    const buttonElement = this.buttonElement;
    
    if (this.direction === 'prev') {
        this.loader.classList.remove('hidden');
        this.loaderTextElement.innerText = `${this.settings.loadingText}`;
        if (loaderNext) loaderNext.querySelector('a').innerText = this.settings.loadMoreText;
    }
    if (this.direction === 'next') {
        if (loaderNext) loaderNext.querySelector('a').innerText = `${this.settings.loadingText}`;
        if (buttonElement) {
            const buttonText = buttonElement.querySelector('button');
            if (buttonText) buttonText.textContent = this.settings.loadingText;
        }
        this.loader.classList.add('hidden');
    }
}

export function removeLoader() {
    const loaderNext = this.paginationNextElement;
    const buttonElement = this.buttonElement;
    
    this.loader.classList.add('hidden');
    if (loaderNext) loaderNext.querySelector('a').innerText = this.settings.loadMoreText;
    if (buttonElement) {
        const buttonText = buttonElement.querySelector('button');
        if (buttonText) buttonText.textContent = this.settings.loadMoreText;
    }
}